import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, Validators } from '@angular/forms';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { DriversService } from 'src/app/component/drivers/drivers-service/drivers-service';
import { FleetService } from 'src/app/component/fleet/fleet-service/fleet.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import * as moment from 'moment-timezone';
import { AssigTripsService } from '../../../assigntrips-service/assigntrips-service';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceAreasService } from 'src/app/component/service-areas/service-areas-service/service-areas.service';

@Component({
  selector: 'app-planner-mapper-add',
  templateUrl: './planner-mapper-add.component.html',
  styleUrls: ['./planner-mapper-add.component.css']
})
export class PlannerMapperAddComponent implements OnInit, OnDestroy {
  user;
  driverList;
  status = "active";
  fleetList = [];
  preDriver = {};
  selectedFleet = [];
  selectedDriver;
  plannerTemplateForm: UntypedFormGroup;
  templateId;
  preFleet;
  isSubmitted = false;
  preServiceAreas = {};
  driverWithFleets = [];
  driverWithoutFleets = [];


  constructor(
    private fb: UntypedFormBuilder,
    private fleetService: FleetService,
    private sharedDataService: SharedDataService,
    private driverService: DriversService,
    private assignTripsService: AssigTripsService,
    private activatedRoute: ActivatedRoute,
    private serviceArea: ServiceAreasService,
    private router: Router
  ) { }

  ngOnInit() {
    this.activatedRoute.params
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((params) => {
        this.templateId = params["id"];
      });

    this.plannerTemplateForm = this.fb.group({
      mappers: this.fb.array([]),
      title: ['', Validators.required],
      // date: ['', Validators.required],
      // preDate: ['']
    });

    this.getUser();
  }


  getUser() {
    this.sharedDataService.getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          this.getFleetList();
          this.getDriverList();
          this.getServiceAreas();

        }
      });
  }

  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        });
  }

  getFleetList() {
    this.fleetService
      .getFleetList({ 'isFleetSection': true, 'status': this.status })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.fleetList = data;
            this.preFleet = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }



  getDriverList() {
    this.driverService.getDrivers(this.user._id, 'active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.driverList = data;
            this.preDriver = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

            if (!this.templateId) {
              let prePlannerData = [];

              for (let driver of this.driverList) {
                prePlannerData.push({ driver: driver._id, fleet: '' });
              }

              this.addPlanner(prePlannerData);
            } else {
              this.getTemplate();
            }
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  getTemplate() {
    this.assignTripsService
      .getPlannerTemplateById(this.templateId)
      .subscribe(data => {
        if (data) {
          let mappers = data.mappers;
          this.plannerTemplateForm.patchValue({
            title: data.title,
            date: data.date
          });
          let prePlannerData = [];
          this.selectedFleet = [];
          for (let driver of this.driverList) {
            const fleetId = mappers ? mappers[driver._id] : undefined;
            prePlannerData.push({ driver: driver._id, fleet: fleetId ? fleetId : '' });
            if (fleetId) {
              this.selectedFleet.push({ driverId: driver._id, fleetId });
            }
          }
          this.addPlanner(prePlannerData);
        }
      });
  }

  addPlanner(prePlanner?) {
    // if(this.plannerTemplateForm.invalid) return;
    const items = this.plannerTemplateForm.get('mappers') as UntypedFormArray
    if (prePlanner) {
      for (const plannerItem of prePlanner) {
        items.push(
          this.fb.group({
            driver: [plannerItem.driver],
            fleet: [plannerItem.fleet]
          })
        );
      }
      return;
    }
    items.push(this.fb.group({
      driver: ['', Validators.required],
      fleet: ['', Validators.required]
    }))
  }

  onDateChange(evt) {
    this.plannerTemplateForm.patchValue({
      date: moment(evt).toISOString()
    });
  }

  onFleetChange(evt, formGroup?) {
    const driverId = formGroup.get('driver').value;
    if (evt) {
      const index = this.selectedFleet.findIndex(f => f.driverId === driverId);
      if (index !== -1) {
        this.selectedFleet[index].fleetId = evt;
      } else {
        this.selectedFleet.push({ driverId, fleetId: evt });
      }
    } else {
      this.selectedFleet = this.selectedFleet.filter(f => f.driverId !== driverId);
      formGroup.get('fleet').setValue('');
    }
  }
  isFleetDisabled(fleetId: string) {
    return this.selectedFleet.some(f => f.fleetId === fleetId);
  }

  onSave() {
    this.isSubmitted = true;
    if (this.plannerTemplateForm.invalid) {
      return;
    }
    let payload = this.plannerTemplateForm.value;
    let mappers = payload.mappers.filter(m => m.driver && m.fleet);
    let newMappers = {}
    mappers.forEach(m => {
      newMappers[m.driver] = m.fleet
    });
    payload = {
      ...payload,
      mappers: newMappers
    }
    this.assignTripsService
      .savePlannerTemplate(payload, this.templateId)
      .subscribe(data => {
        if (data) {
          this.router.navigateByUrl("planner/mapper");
        }
      });
  }

  get form() {
    return this.plannerTemplateForm.controls;
  }

  get plannerForm() {
    return this.plannerTemplateForm.get('mappers') as UntypedFormArray;
  }

  ngOnDestroy() {
  }


}
